import { render } from "./memo.vue?vue&type=template&id=33a6373c&scoped=true"
import script from "./memo.vue?vue&type=script&lang=js"
export * from "./memo.vue?vue&type=script&lang=js"

import "./memo.vue?vue&type=style&index=0&id=33a6373c&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a6373c"]])

export default __exports__